import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import {
  AnalyticsBatchResponseDto,
  AnalyticsEventDto,
} from "./dto/analytics/analytics-event-dto.model";

const API_ANALYTICS_EVENTS_URL = `${environment.apiUrl}analytics/events/`;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsHTTPService {
  constructor(private http: HttpClient) {}

  trackBatch(events: AnalyticsEventDto[]): Observable<AnalyticsBatchResponseDto> {
    return this.http.post<AnalyticsBatchResponseDto>(
      API_ANALYTICS_EVENTS_URL,
      { events }
    );
  }
}
